var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-container",staticStyle:{"display":"flex","flex-wrap":"nowrap","width":"83px"}},[_c('div',{staticStyle:{"width":"83px","height":"60px"},attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }